<template>
  <v-card class="mb-4" elevation="2">
    <v-card-title>
      Teilnehmer*innen
      <v-spacer></v-spacer>
      <v-btn color="primary" small @click="addParticipant">
        <v-icon left>mdi-plus</v-icon>
        Hinzufügen
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row v-for="(participant, index) in participants" :key="index" align="center">
        <v-col cols="10">
          <v-text-field
              :value="participant.firstName"
              @input="updateParticipant(index, $event)"
              :rules="[v => !!v || 'Vorname ist erforderlich']"
              :label="'Vorname Teilnehmer*in ' + (index + 1) + ' (erscheint auf der Startnummer)'"
              required
              dense
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-btn
              icon
              color="error"
              @click="removeParticipant(index)"
              :disabled="participants.length <= 1"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ParticipantsCard',
  props: {
    participants: {
      type: Array,
      required: true
    }
  },
  methods: {
    addParticipant() {
      const newParticipants = [...this.participants, { firstName: '' }];
      this.$emit('update:participants', newParticipants);
    },
    removeParticipant(index) {
      if (this.participants.length > 1) {
        const newParticipants = this.participants.filter((_, i) => i !== index);
        this.$emit('update:participants', newParticipants);
      }
    },
    updateParticipant(index, value) {
      const newParticipants = [...this.participants];
      newParticipants[index] = { ...newParticipants[index], firstName: value };
      this.$emit('update:participants', newParticipants);
    }
  }
}
</script>
